
import { mapState, mapGetters, mapActions } from 'vuex';
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import SocialMediaType from '@/enums/SocialMediaType';
import ReviewMediaSectionPc from './components/ReviewMediaSectionPc';
import ProductReviewThumbnailsSection from './components/ProductReviewThumbnailsSection';

export default {
  i18nComponentKey: 'ReviewsShow.ReviewsShowPc',
  name: 'ReviewsShowPc',
  components: {
    ReviewMediaSectionPc,
    ProductReviewThumbnailsSection
  },
  mixins: [PaginatedReviewResourceView],
  data() {
    return {
      REVIEW_THUMBNAILS_PER_PAGE: 12,
      selectedMediaPosition: null,
      selectedReviewIndex: null,
      thumbnailClicked: false
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('review', ['isManagerReview']),
    ...mapGetters('review', { parentWidgetReviews: 'reviews' }),
    ...mapGetters('reviewSettings', ['isAuthorDisplayTypeUserGrade']),
    ...mapGetters('widget', ['nthReviewWidgetStylePopup']),
    ...mapGetters(['fromTargetWidget']),
    ...mapState('window', ['windowService']),
    ...mapState('widget', ['reviewId']),
    ...mapState('review', ['mediaIndex']),
    ...mapState('productReviewThumbnails', {
      thumbnailReviews: 'reviews',
      thumbnailPagy: 'pagy'
    }),
    ...mapState('productReviewThumbnails', [
      'isLoadingProductReviewThumbnails'
    ]),
    ...mapState('review', { parentWidgetPagy: 'pagy' }),
    SocialMediaType: () => SocialMediaType,
    defaultResourceParams() {
      const params = {
        per: this.REVIEW_THUMBNAILS_PER_PAGE,
        fields: this.fields
      };

      if (this.fromTargetWidget && this.reviewId)
        params.review_id = this.reviewId;

      return params;
    },
    fields() {
      return [
        'reviews.customer_properties',
        'reviews.display_user_options',
        this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : '',
        'reviews.evaluation_properties',
        this.reviewSettings.use_comments ? 'reviews.comments' : '',
        this.nthReviewWidgetStylePopup ? 'reviews.with_parent_reviews' : ''
      ]
        .filter(v => v)
        .join(',');
    },
    selectedReview() {
      return this.reviews[this.selectedReviewIndex];
    },
    enablePrev() {
      return this.selectedReviewIndex > 0 || !!this.pagy.prev;
    },
    enableNext() {
      if (this.thumbnailClicked && this.isLoadingProductReviewThumbnails)
        return false;
      return (
        this.selectedReviewIndex < this.reviews.length - 1 || !!this.pagy.next
      );
    },
    reviews() {
      return this.thumbnailClicked
        ? this.thumbnailReviews
        : this.parentWidgetReviews;
    },
    pagy() {
      return this.thumbnailClicked ? this.thumbnailPagy : this.parentWidgetPagy;
    }
  },
  async mounted() {
    await this.fetchFacebooks();
  },
  methods: {
    ...mapActions('facebook', ['fetchFacebooks']),
    ...mapActions('productReviewThumbnails', ['fetchProductReviewThumbnails']),
    onReady() {
      if (this.selectedReviewIndex === null) {
        this.selectedReviewIndex = this.reviews.findIndex(
          r => r.id.toString() === this.reviewId
        );
      }
      if (this.selectedReviewIndex < 0) {
        if (this.reviews.length) {
          this.windowService.alert(this.$t('filtered_review_mismatch'));
          this.selectedReviewIndex = 0;
        } else {
          this.windowService.alert(this.$t('filtered_review_none'));
          this.onClose();
          return;
        }
      }
      if (this.mediaIndex && !this.selectedMediaPosition) {
        this.selectedMediaPosition = Number(this.mediaIndex);
      } else {
        this.selectedMediaPosition = 1;
      }
      this.$emit('ready');
    },
    onPrev() {
      if (!this.enablePrev) return;

      this.selectedMediaPosition = 1;
      if (this.selectedReviewIndex > 0) {
        this.selectedReviewIndex -= 1;
      } else if (this.pagy.prev) {
        this.prependPage(this.pagy.prev).then(() => {
          this.selectedReviewIndex =
            this.selectedReviewIndex + this.pagy.items - 1;
        });
      }
    },
    onNext() {
      if (!this.enableNext) return;

      this.selectedMediaPosition = 1;
      if (this.selectedReviewIndex < this.reviews.length - 1) {
        this.selectedReviewIndex += 1;
      } else if (this.pagy.next) {
        if (this.thumbnailClicked) {
          this.fetchProductReviewThumbnails({
            product_code: this.selectedReview.product_code,
            page: this.pagy.next,
            fields: this.defaultResourceParams.fields,
            append: true
          }).then(() => {
            this.selectedReviewIndex += 1;
          });
        } else {
          this.appendPage({ page: this.pagy.next }).then(() => {
            this.selectedReviewIndex += 1;
          });
        }
      }
    },
    onChangeSelectedThumbnail(reviewIndex) {
      this.selectedReviewIndex = reviewIndex;
      this.thumbnailClicked = true;
      this.selectedMediaPosition = 1;
    },
    onClose() {
      this.windowService.closeFullscreenPopup();
    }
  }
};
